import QmBusinessState from './src/main';

/* istanbul ignore next */
QmBusinessState.install = function(Vue) {
  Vue.component(QmBusinessState.name, QmBusinessState);
};

export default QmBusinessState;
